export class Rating {
  id: number;
  value: number;

  constructor(init: Partial<Rating>) {
    this.id = init.id ?? 0;
    this.value = init.value ?? 0;
  }
}
